import React, { Component } from 'react';
import {
    Card,
    Badge,
    ButtonDropdown,
    CustomInput,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
} from 'reactstrap';
import { connect } from 'react-redux';
import {
    setContainerClassnames,
    clickOnMobileMenu,
} from '../../../redux/actions';
import IntlMessages from '../../../helpers/IntlMessages';
import classnames from 'classnames';
import { Separator } from '../../../components/common/CustomBootstrap';
import moment from 'moment';

class LabelItemLeft extends Component {
    constructor(props) {
        super(props);

        this.state = {
            dropdownSplitOpen: false,
        };
    }

    toggleSplit = () => {
        this.setState((prevState) => ({
            dropdownSplitOpen: !prevState.dropdownSplitOpen,
        }));
    };

    menuButtonClick = (e, menuClickCount, containerClassnames) => {
        setTimeout(() => {
            var event = document.createEvent('HTMLEvents');
            event.initEvent('resize', false, false);
            window.dispatchEvent(event);
        }, 350);
        this.props.setContainerClassnames(
            menuClickCount,
            containerClassnames,
            this.props.selectedMenuHasSubItems
        );
    };

    onClickedItem = (item) => {
        this.props.onClickedItem(
            // callback
            item,
            this.menuButtonClick,
            [null, 1000, this.props.containerClassnames]
        );
    };

    render() {
        const { setting, item } = this.props;
        const { dropdownSplitOpen } = this.state;

        return (
            <Card className='mb-3 custom-shadow'>
                <div className='d-flex flex-row cursor-pointer'>
                    <div
                        className={classnames(
                            item.status_name === 'Hoàn thành' ? 'disable' : '',
                            'd-flex flex-grow-1 min-width-zero'
                        )}
                        // className={'d-flex flex-grow-1 min-width-zero'}
                    >
                        <div
                            onClick={() => {
                                item.status_name === 'Hoàn thành'
                                    ? this.props.onUpdateStatus(
                                          this.props.item,
                                          0
                                      )
                                    : this.props.onUpdateStatus(
                                          this.props.item,
                                          1
                                      );
                                // this.onClickedItem(this.props.item);
                            }}
                            className={classnames(
                                'card-body align-self-center d-flex flex-ssm-column justify-content-between min-width-zero',
                                {
                                    'flex-lg-row align-items-lg-center':
                                        !setting.update,
                                }
                            )}
                        >
                            <div
                                className={classnames(
                                    item.status_name === 'Hoàn thành'
                                        ? 'text-deco-line-through'
                                        : '',
                                    'w-100 list-item-heading mb-1 truncate d-block'
                                )}
                                // className='w-100 list-item-heading mb-1 truncate d-block'
                            >
                                <span>{this.props.item.title}</span>
                                <p className='text-muted mt-2 mb-0'>
                                    {this.props.item.description}
                                </p>
                            </div>
                            <div className='w-40 d-flex flex-column align-items-center'>
                                <p>
                                    <Badge color='primary' pill>
                                        {item.status_name}
                                    </Badge>
                                </p>
                                <p
                                    className={classnames(
                                        item.status_name === 'Hoàn thành'
                                            ? 'text-deco-line-through'
                                            : '',
                                        'text-small text-muted m-0'
                                    )}
                                    // className='text-small text-muted m-0'
                                >
                                    {this.props.item.time +
                                        ' / ' +
                                        moment(this.props.item.date).format(
                                            'YYYY-MM-DD'
                                        )}
                                </p>
                                {/* <Badge
                                    color={
                                        this.props.item.status_id
                                            ? 'primary'
                                            : 'secondary'
                                    }
                                    pill
                                >
                                    {this.props.item.status_name}
                                </Badge> */}
                            </div>
                        </div>
                        {this.props.item.status_name === 'Hoàn thành' ? null : (
                            <div className='custom-control custom-checkbox pl-1 align-self-center pr-4'>
                                <ButtonDropdown
                                    isOpen={dropdownSplitOpen}
                                    toggle={this.toggleSplit}
                                    onClick={(e) => e.stopPropagation()}
                                    // onClick={() => {
                                    //     this.onClickedItem(this.props.item);
                                    // }}
                                >
                                    <div 
                                        className={classnames(
                                            'cursor-pointer btn btn-lg btn-secondary pl-4 pr-0 check-button check-all',
                                            {
                                                'btn-primary': dropdownSplitOpen || this.props.selectedItems.includes(
                                                this.props.item.id),
                                            }
                                        )}
                                    >
                                        <CustomInput
                                            className='custom-checkbox mb-0 d-inline-block'
                                            type='checkbox'
                                            id={this.props.idx}
                                            checked={this.props.selectedItems.includes(
                                                this.props.item.id
                                            )}
                                            onChange={() => {
                                                this.props.onChangeCheckbox(
                                                    this.props.item.id
                                                );
                                            }}
                                            label={
                                                <span
                                                    className={`custom-control-label`}
                                                />
                                            }
                                        />
                                    </div>
                                    <DropdownToggle
                                        caret
                                        color={dropdownSplitOpen || this.props.selectedItems.includes(
                                            this.props.item.id) ? 'primary' : 'secondary'}
                                        className='dropdown-toggle-split'
                                        onClick={() => {
                                            this.props.onChangeCheckbox(
                                                this.props.item.id
                                            );
                                        }}
                                    />
                                    <DropdownMenu right>
                                        <DropdownItem
                                            className={classnames('text-left', {
                                                disable:
                                                    this.props.isDisabledUpdate,
                                            })}
                                            onClick={() =>
                                                this.props.isDisabledUpdate
                                                    ? null
                                                    : this.props.onUpdate(
                                                          this.props.item
                                                      )
                                            }
                                        >
                                            <i className='simple-icon-note pr-2' />
                                            <IntlMessages id='pages.update' ˇ />
                                        </DropdownItem>
                                        {/* <Separator />
                                    <DropdownItem
                                        className={classnames('text-left', {
                                            disable:
                                                this.props.isDisabledUpdate,
                                        })}
                                        onClick={() =>
                                            this.props.isDisabledUpdate
                                                ? null
                                                : this.props.onUpdateStatus(
                                                      this.props.item,
                                                      1
                                                  )
                                        }
                                    >
                                        <i className='simple-icon-check pr-2' />
                                        <IntlMessages id='todo.update-done' ˇ />
                                    </DropdownItem>
                                    <Separator />
                                    <DropdownItem
                                        className={classnames('text-left', {
                                            disable:
                                                this.props.isDisabledUpdate,
                                        })}
                                        onClick={() =>
                                            this.props.isDisabledUpdate
                                                ? null
                                                : this.props.onUpdateStatus(
                                                      this.props.item,
                                                      0
                                                  )
                                        }
                                    >
                                        <i className='simple-icon-minus pr-2' />
                                        <IntlMessages
                                            id='todo.update-pending'
                                            ˇ
                                        />
                                    </DropdownItem> */}
                                        <Separator />
                                        <DropdownItem
                                            className={classnames(
                                                'text-left red',
                                                {
                                                    disable:
                                                        this.props
                                                            .isDisabledDelete,
                                                }
                                            )}
                                            onClick={() =>
                                                this.props.isDisabledDelete
                                                    ? null
                                                    : this.props.onDelete(
                                                          this.props.item
                                                      )
                                            }
                                        >
                                            <>
                                                <i className='simple-icon-trash pr-2' />
                                                <IntlMessages id='pages.delete' />
                                            </>
                                        </DropdownItem>
                                    </DropdownMenu>
                                </ButtonDropdown>
                            </div>
                        )}
                    </div>
                </div>
            </Card>
        );
    }
}

const mapStateToProps = ({ menu }) => {
    const { containerClassnames, menuClickCount, selectedMenuHasSubItems } =
        menu;
    return {
        containerClassnames,
        menuClickCount,
        selectedMenuHasSubItems,
    };
};
export default connect(mapStateToProps, {
    setContainerClassnames,
    clickOnMobileMenu,
})(LabelItemLeft);
